export default __webpack_public_path__ + "static/media/AHA-logo-white.2208e617.svg";